import { Link } from 'react-router-dom'

/** Equivalent of legacy `PaymentSuccessComponent` (current `/payment/success`
 * — the `/payment/old/success` variant is not ported, see PaymentHomePage). */
export function PaymentSuccessPage() {
  return (
    <div className="screener-card screener-card--notice">
      <h1>Payment successful</h1>
      <p>Thank you — your payment was processed successfully.</p>
      <Link to="/payment">Back to payment overview</Link>
    </div>
  )
}
